import { render, staticRenderFns } from "./BalancoPatrimonialPeriodo.vue?vue&type=template&id=4f2b6fbe&scoped=true"
import script from "./BalancoPatrimonialPeriodo.vue?vue&type=script&lang=js"
export * from "./BalancoPatrimonialPeriodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2b6fbe",
  null
  
)

export default component.exports